// Single source of truth for the area-stipple dot grid shared by every stipple
// implementation: lib/renderers.js (`fillDotsInPath` + the stacked-area layer
// fill), components/kernelPrimitives/shared.jsx (`fillStippleRect` /
// `fillStipplePath`), and the SVG pattern under the Triage tab's time window
// (components/TriageTimeWindow.jsx). Keeping the spacing here stops them drifting.
//
//   STIPPLE_SIZE       — dot-grid spacing in CSS px. This is the DENSITY knob
//                        (dots per area); lower = denser. Change it here and
//                        every stipple surface (activity chart, sparklines,
//                        kernel primitives) tracks it.
//   STIPPLE_DOT_RADIUS — default dot weight. Some contexts intentionally vary
//                        it (e.g. the top stacked layer renders a touch larger);
//                        those pass an explicit override.
export const STIPPLE_SIZE = 5;
export const STIPPLE_DOT_RADIUS = 0.8;

// Sparklines are tiny (~14px tall, ~10px plot). The standard grid yields only
// 2–3 dot rows there, and because the grid is anchored (not line-relative) the
// number of rows caught under the curve swings between 1 and 3 — so the fill
// reads patchy and looks like it "stops" below the line. The compact preset
// packs the grid tight enough (with a slightly smaller dot) that the residual
// row gap is sub-pixel and the short fill reads as a continuous texture down to
// the baseline regardless of where the line sits.
export const STIPPLE_SIZE_COMPACT = 2.5;
export const STIPPLE_DOT_RADIUS_COMPACT = 0.75;
